import {RouterModule, Routes} from '@angular/router';
import {CampaignCreateComponent} from './campaign-create/campaign-create.component';
import {CampaignManageComponent} from './campaign-manage/campaign-manage.component';
import {CampaignCompleteComponent} from './campaign-complete/campaign-complete.component';
import {AuthorizationGuard} from '../shared/guards/authorization.guard';
import {CampaignComponent} from './campaign.component';
import {CampaignFinalOrderComponent} from "./campaign-final-order/campaign-final-order.component";

const CAMPAIGN_ROUTES: Routes = [
    {
        path: '',
        redirectTo: '/campaign',
        pathMatch: 'full'
    },
    {
        path: '',
        component: CampaignComponent,
        data: {title: 'Campaign Router'}
    },
    {
        path: 'create',
        component: CampaignCreateComponent,
        data: {title: 'Create Campaign'},
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'manage/:id',
        component: CampaignManageComponent,
        data: {title: 'Manage Campaign'},
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'complete/:id',
        component: CampaignCompleteComponent,
        data: {title: 'Complete Campaign'},
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'thank-you/:id',
        component: CampaignFinalOrderComponent,
        data: {title: 'Final Order Received'},
        canActivate: [AuthorizationGuard]
    }
];

export const CampaignRouting = RouterModule.forChild(CAMPAIGN_ROUTES);



// WEBPACK FOOTER //
// ./src/app/campaign/campaign.routing.ts